import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ProjectGet } from '@app/services/project.service';

@Component({
    selector: 'tt-project-view',
    templateUrl: './project-view.component.html',
    styleUrls: ['./project-view.component.css'],
})
export class ProjectViewComponent {
    public webpageHeading = '';

    public params: { project_keyno: string };

    constructor(private state: StateService) {
        this.params = state.getStateParams() as { project_keyno: string };
    }

    public onSubmit() {
        this.state.back();
    }

    public setHeading(projectGet: ProjectGet) {
        this.webpageHeading = projectGet.project_name;
        this.state.setTitleOverride(this.webpageHeading);
    }
}
